import { PolicyRequest } from '../policy-create';
import { TOKENIZATION_STATE } from '../traveller-payments/types';

export const RESET_QUOTE = 'RESET_QUOTE';
export const RE_QUOTE_START = 'RE_QUOTE_START';
export const RE_QUOTE_SUCCESS = 'RE_QUOTE_SUCCESS';
export const RE_QUOTE_FAILED = 'RE_QUOTE_FAILED';

export const POLICY_UPDATE_START = 'POLICY_UPDATE_START';
export const POLICY_UPDATE_SUCCESS = 'POLICY_UPDATE_SUCCESS';
export const POLICY_UPDATE_FAILED = 'POLICY_UPDATE_FAILED';

export const POLICY_RETRY_START = 'POLICY_RETRY_START';
export const POLICY_RETRY_SUCCESS = 'POLICY_RETRY_SUCCESS';
export const POLICY_RETRY_FAILED = 'POLICY_RETRY_FAILED';

export const ENDORSEMENT_PAYMENT_DETAILS = 'ENDORSEMENT_PAYMENT_DETAILS';
export const ENDORSEMENT_INITIATE_TOKEN = 'ENDORSEMENT_INITIATE_TOKEN';

export const SHOW_APPLY_CHANGES = 'SHOW_APPLY_CHANGES';

export interface ApiErrorMessage {
  errorMessage?: string;
  errorRef?: string;
}

export interface RequoteError extends ApiErrorMessage {
  changeRequest?: string[];
}

export interface PolicyUpdate {
  requoteResponse?: PolicyRequest;
  deltaTotal?: number;
  deltaPaxes?: DeltaPax[];
  requoteError?: RequoteError;
  requoteDone?: boolean;
  requoteLoading?: boolean;
  updateResponse?: PolicyRequest;
  updateError?: ApiErrorMessage;
  updateLoading?: boolean;
  retryResponse?: PolicyRequest;
  retryError?: ApiErrorMessage;
  retryLoading?: boolean;
  endorsementPayment?: EndorsementPayment;
  showApplyChanges?: boolean;
}

export interface DeltaPax {
  policyNumber?: string;
  deltaAmount?: number;
}

export interface EndorsementPayment {
  paymentMethod?: ENDORSEMENT_PAYMENT_METHOD;
  paymentAmount?: number;
  token?: string;
  expiryDate?: string;
  cvv?: string;
  cardHolderName?: string;
  ccType?: string;
  tokenError?: string[];
  tokenState?: TOKENIZATION_STATE;
}

export enum ENDORSEMENT_PAYMENT_METHOD {
  TOKEN = 'TOKEN',
  ORIGINAL = 'ORIGINAL',
  CREDIT_CARD = 'CREDIT_CARD',
  CASH = 'CASH',
  AGENCY = 'PAID_TO_AGENCY',
  CHARGEBACK = 'CHARGEBACK'
}
